import Reflux from "reflux";

export const ActionsProfile = Reflux.createActions({
  createProfile: { asyncResult: true },
  patchProfile: { asyncResult: true },
  deleteProfile: { asyncResult: true },
  getProfilesByOrganizationId: { asyncResult: true },
  getProfileByOrganizationId: { asyncResult: true },
  getDomainSkillsByJobCategoryId: { asyncResult: true },
  generateWhatsappForm: { asyncResult: true },
  createDomainSkill: { asyncResult: true },
  filterProfileById: {},
  getCategoriesByJobCategoryId: { asyncResult: true }
});
